// extracted by mini-css-extract-plugin
export default {"Login":"login_Login__KdRpS","Separator":"login_Separator__dnwMq","SplashContent":"login_SplashContent__H8M8T","LoginForm__AlertImg":"login_LoginForm__AlertImg__p5FEX"};